import { ChakraText, EmptySectionCard, Text } from '@equip.health/ui';

const SMTEmptySection = ({
  onGoToCarePlan,
}: {
  onGoToCarePlan: () => void;
}) => {
  return (
    <EmptySectionCard
      caption={
        <Text color="neutral.secondary" variant="body">
          Equip Journal has not been turned on for this patient. Please{' '}
          <ChakraText
            as="span"
            color="primary.100"
            cursor="pointer"
            onClick={onGoToCarePlan}
            textDecoration="underline"
          >
            go to the care plan
          </ChakraText>{' '}
          to configure.
        </Text>
      }
      id="smt-empty-section"
    />
  );
};

export default SMTEmptySection;
